import React from 'react';
import BottomNav from '../components/BottomNav';

const PrivateInvitations = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Private Invitations</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Exclusive Member Events</p>
        
        <div className="card">
          <p>
            Receive invitations to the most exclusive private events and gatherings. 
            Network with elite members and enjoy once-in-a-lifetime experiences.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Private Gatherings</h3>
              <p>Intimate events with industry leaders and influencers</p>
            </div>
            <div className="feature-item">
              <h3>VIP Experiences</h3>
              <p>Invitation-only access to premier occasions</p>
            </div>
            <div className="feature-item">
              <h3>Networking</h3>
              <p>Connect with like-minded individuals globally</p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default PrivateInvitations;
